import { gql } from "apollo-boost";

export const GET = gql`
  {
    users {
      id
      name
      email
      password
      role
      owner
    }
  }
`;

export const GET_BY_USER_ID = gql`
  query user($id: String!) {
    user(id: $id) {
      id
      name
      email
      owner
    }
  }
`;

export const ADD = gql`
  mutation createUser(
    $name: String!
    $email: String!
    $password: String!
    $role: String!
    $owner: Boolean!
  ) {
    createUser(
      input: {
        name: $name
        email: $email
        password: $password
        role: $role
        owner: $owner
        systems: ["PUB"]
      }
    ) {
      id
      name
      email
      password
      role
      owner
    }
  }
`;

export const EDIT_CLIENT = gql`
  mutation updateUser(
    $id: String!
    $name: String!
    $email: String!
    $password: String
    $owner: Boolean!
  ) {
    updateUser(
      id: $id
      input: { name: $name, email: $email, password: $password, owner: $owner }
    ) {
      id
      name
      email
      password
      role
      owner
    }
  }
`;

export const EDIT = gql`
  mutation updateUser(
    $id: String!
    $name: String!
    $email: String!
    $password: String
    $role: String!
    $owner: Boolean!
  ) {
    updateUser(
      id: $id
      input: {
        name: $name
        email: $email
        password: $password
        role: $role
        owner: $owner
      }
    ) {
      id
      name
      email
      password
      role
      owner
    }
  }
`;

export const DELETE = gql`
  mutation deleteUser($id: String!) {
    deleteUser(id: $id) {
      id
    }
  }
`;
